import type { NextApiRequest } from "next";

import rateLimit from "@calcom/lib/rateLimit";

const forgotPasswordIpLimiter = rateLimit({ intervalInMs: 15 * 60 * 1000 });

export function getClientIp(req: NextApiRequest): string {
  const forwarded = req.headers["x-forwarded-for"];
  if (typeof forwarded === "string") {
    return forwarded.split(",")[0]?.trim() ?? "unknown";
  }
  return req.socket?.remoteAddress ?? "unknown";
}

/** Limits forgot-password requests per IP to reduce abuse / email flooding. */
export function assertForgotPasswordNotRateLimited(req: NextApiRequest): void {
  const ip = getClientIp(req);
  forgotPasswordIpLimiter.check(10, `forgot-password:ip:${ip}`);
}

/**
 * E2E returns a reset link; only allow navigation to our own forgot-password token page.
 */
export function isSafeForgotPasswordResetLink(link: string): boolean {
  const base = process.env.NEXT_PUBLIC_WEBAPP_URL;
  if (!base) {
    return false;
  }
  try {
    const baseUrl = new URL(base);
    const resolved = new URL(link, baseUrl);
    if (resolved.origin !== baseUrl.origin) {
      return false;
    }
    return /^\/auth\/forgot-password\/[^/]+$/.test(resolved.pathname);
  } catch {
    return false;
  }
}
